import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate("/");
        }, 3000);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div style={ { textAlign: "center", padding: "50px" } }>
            <h1>404 - Page Not Found</h1>
            <p>Redirecting to home...</p>
        </div>
    );
};

export default NotFound;